/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-lonely-if */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Button from "components/Button";
import Divider from "components/Divider";
import H1 from "components/H1";
import H4 from "components/H4";
import TextInput from "components/TextInput";
import Checkbox from "components/Checkbox";
import { useHistory } from "react-router-dom";
import applicationSvc from "services/applicationSvc";
import Svg from "_assets/svg";
import DividerCheckbox from "./DividerCheckbox";
import SmsChannel from "./SmsChannel";
import WhatsappChannel from "./WhatsappChannel";
import Wrapper from "./Wrapper";
import authSvc from "services/authSvc";
import userSvc from "services/userSvc";
import organizationSvc from "services/organizationSvc";
import channelSvc from "services/channelSvc";
import { channelConstant } from "_constant";

const CreateApplicationPage = () => {
  const [applicationName, setApplicationName] = useState("");
  const [whatsapp, setWhatsapp] = useState(false);
  const [sms, setSms] = useState(false);
  const [call, setCall] = useState(false);
  const [voiceOTP, setVoiceOTP] = useState(false);
  const [isEmail, setEmail] = useState(false);
  const [smsOTP, setSmsOTP] = useState(false);
  // const [isChatAja, setChatAja] = useState(false);
  const [channelForm, setChannelForm] = useState({});
  const [loading, setLoading] = useState(false);
  const initialValidation = {
    applicationName: "",
    channelOption: "",
    senderName: "",
    senderNumber: "",
  };
  const [validation, setValidation] = useState(initialValidation);
  const [error, setError] = useState("");
  const [user, setUser] = useState();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      // get user
      const currUser = authSvc.currentUser();
      const userData = await userSvc.get(currUser?.user?.id);
      setUser(userData?.data?.data);
    })();

    if (!channelForm) {
      const initialChannelForm = {
        image: { view: "", raw: "" },
        senderName: "",
        senderNumber: "",
      };
      setChannelForm(initialChannelForm);
    }
  }, []);

  const validateForm = () => {
    let updValidation = initialValidation;
    // const { senderName, senderNumber } = channelForm;
    if (!applicationName) {
      updValidation = { ...updValidation, applicationName: "Application name is required" };
    }
    if (!whatsapp && !sms && !smsOTP && !call && !voiceOTP && !isEmail) {
      updValidation = { ...updValidation, channelOption: "Must be at least 1 channel" };
    } else {
      // if (whatsapp) {
      //   if (!senderName) {
      //     updValidation = { ...updValidation, senderName: "This Field is required" };
      //   }
      // }
      // if (sms) {
      //   if (!senderName) {
      //     updValidation = { ...updValidation, senderName: "This Field is required" };
      //   }
      //   if (!senderNumber) {
      //     updValidation = { ...updValidation, senderNumber: "This Field is required" };
      //   }
      // }
    }

    setValidation(updValidation);

    let result = true;
    Object.entries(updValidation).forEach(([key, val]) => {
      if (val) result = false;
    });
    return result;
  };

  const handleCreate = async () => {
    setLoading(true);
    const isValidate = validateForm();
    let hasWAChannel = false;
    if (isValidate) {
      const { id: userId, organization } = user;
      const channels = [];
      const { senderName, senderNumber, image } = channelForm;
      if (whatsapp) {
        hasWAChannel = true;
        channels.push({
          channel: channelConstant.whatsapp,
          senderImageUrl: "",
          senderName,
        });
      }
      if (sms) {
        channels.push({
          channel: channelConstant.sms,
          senderName,
          senderNumber,
        });
      }
      if (smsOTP) {
        channels.push({
          channel: channelConstant.smsOtp,
          senderName,
          senderNumber,
        });
      }
      if (call) {
        channels.push({
          channel: channelConstant.call,
        });
      }
      if (voiceOTP) {
        channels.push({
          channel: channelConstant.voiceOtp,
        });
      }
      if (isEmail) {
        channels.push({
          channel: channelConstant.email,
        });
      }
      // if (isChatAja) {
      //   channels.push({
      //     channel: channelConstant.chatAja,
      //   });
      // }


      const submitData = {
        userId,
        organizationId: organization,
        applicationName,
      };


      try {
        setError("");
        // let fileUpload;
        // if (image?.raw && hasWAChannel) {
        //   fileUpload = await userSvc.upload(channelForm.image?.raw);
        //   const indexWA = channels.findIndex((item) => item.channel === channelConstant.whatsapp);
        //   channels[indexWA].senderImageUrl = fileUpload?.data?.data?.url ?? "";
        // }

        const data = await applicationSvc.create({ ...submitData, channels });
        const appId = data.data.data.id;
        const privateKey = await applicationSvc.generatePem(appId);
        downloadPem(privateKey.data, appId);
        history.push("/my-application");
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const downloadPem = (text, appId) => {
    const element = document.createElement("a");
    const file = new Blob([text], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = `${appId}.txt`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  return (
    <div className="row mx-auto align-items-center flex-column">
      <Wrapper className="d-flex flex-column">
        <H1 className="margin-bottom-10">Create application</H1>
        <H4 className="margin-bottom-30">Auto generate API Key and any other information</H4>
        <Divider className="margin-bottom-30" />
        <TextInput
          title="Application name"
          value={applicationName}
          placeholder="E.g. Omni Communication Assistant"
          className="margin-bottom-30 input-auth"
          onChange={(event) => setApplicationName(event.target.value)}
          invalidFeedback={validation.applicationName}
        />
        <H4 className="margin-bottom-15">Choose Channel</H4>
        <Checkbox
          svg={Svg.whatsapp_primary.default}
          title="WhatsApp"
          classNameInput={!!validation.channelOption && "has-error"}
          checked={whatsapp}
          onCheck={(event) => setWhatsapp(event.target.checked)}
        />
        {/* <DividerCheckbox>
          <WhatsappChannel
            active={whatsapp}
            form={channelForm}
            onChange={setChannelForm}
            validation={validation}
          />
          <Divider className="margin-0" />
        </DividerCheckbox> */}
        <Checkbox
          svg={Svg.sms_primary.default}
          title="SMS"
          classNameInput={!!validation.channelOption && "has-error"}
          checked={sms}
          onCheck={(event) => setSms(event.target.checked)}
        />
        <Checkbox
          svg={Svg.sms_primary.default}
          title="SMS OTP"
          classNameInput={!!validation.channelOption && "has-error"}
          checked={smsOTP}
          onCheck={(event) => setSmsOTP(event.target.checked)}
        />
        {/* <Checkbox
          svg={Svg.chat_aja.default}
          title="Chat Aja"
          classNameInput={!!validation.channelOption && "has-error"}
          checked={isChatAja}
          onCheck={(event) => setChatAja(event.target.checked)}
        /> */}
        {/* <DividerCheckbox>
          <SmsChannel
            active={sms}
            form={channelForm}
            onChange={setChannelForm}
            validation={validation}
          />
          <Divider className="margin-0" />
        </DividerCheckbox> */}
        <Checkbox
          svg={Svg.call_primary.default}
          title="Call"
          classNameInput={!!validation.channelOption && "has-error"}
          checked={call}
          onCheck={(event) => setCall(event.target.checked)}
        />
        <Checkbox
          svg={Svg.call_primary.default}
          title="Voice OTP"
          classNameInput={!!validation.channelOption && "has-error"}
          checked={voiceOTP}
          onCheck={(event) => setVoiceOTP(event.target.checked)}
        />
        <Checkbox
          svg={Svg.email.default}
          title="Email"
          classNameInput={!!validation.channelOption && "has-error"}
          checked={isEmail}
          onCheck={(event) => setEmail(event.target.checked)}
        />
        <div
          className="invalid-feedback"
          style={{ display: !!validation.channelOption ? "block" : "none" }}
        >
          {validation.channelOption}
        </div>
        <Button
          className="w-100 margin-top-30"
          loading={loading}
          handleRoute={() => handleCreate()}
          primary
        >
          Create
        </Button>
      </Wrapper>
    </div>
  );
};

export default CreateApplicationPage;
